/* global window */
import { openTaskpaneDialog } from "./taskpaneDialogOpener";
function defaultSettingsDialogUrl(tabId) {
    let dialogUrl = `${window.location.origin}/settings.html`;
    if (tabId) {
        dialogUrl += `?tab=${encodeURIComponent(tabId)}`;
    }
    return dialogUrl;
}
function defaultPromptLibraryDialogUrl(mode) {
    let dialogUrl = `${window.location.origin}/promptLibrary.html`;
    if (mode === "add") {
        dialogUrl += "?mode=add";
    }
    return dialogUrl;
}
function parseJsonMessage(raw, logPrefix, dialogLabel) {
    try {
        return JSON.parse(raw);
    }
    catch (error) {
        console.warn(`${logPrefix} Failed to parse ${dialogLabel} dialog message:`, error);
        return null;
    }
}
export function createTaskpaneAppDialogOpeners(options) {
    const logPrefix = options.logPrefix || "[Taskpane]";
    const settingsDialogOptions = options.settingsDialogOptions || {
        height: 55,
        width: 40,
        displayInIframe: false,
    };
    const promptLibraryDialogOptions = options.promptLibraryDialogOptions || settingsDialogOptions;
    const openSettingsDialog = (tabId) => {
        if (!options.isAuthenticated()) {
            console.log(`${logPrefix} User not authenticated, cannot open settings dialog`);
            return;
        }
        void Promise.resolve(options.resolveSettingsDialogUrl
            ? options.resolveSettingsDialogUrl(tabId)
            : defaultSettingsDialogUrl(tabId))
            .then((dialogUrl) => {
            openTaskpaneDialog({
                dialogUrl,
                requireAuth: true,
                isAuthenticated: options.isAuthenticated,
                options: settingsDialogOptions,
                onOpenFailed: (error) => {
                    options.onSettingsOpenFailed?.(error);
                },
                onMessage: (arg) => {
                    const message = parseJsonMessage(arg.message, logPrefix, "settings");
                    if (message !== null) {
                        options.onSettingsMessage?.(message);
                    }
                },
                onDialogEvent: options.onSettingsDialogEvent,
            });
        })
            .catch((error) => {
            console.error(`${logPrefix} Failed to resolve settings dialog URL:`, error);
        });
    };
    const openPromptLibraryDialog = (mode) => {
        if (!options.isAuthenticated()) {
            console.log(`${logPrefix} User not authenticated, cannot open prompt library dialog`);
            return;
        }
        const dialogUrl = options.resolvePromptLibraryDialogUrl
            ? options.resolvePromptLibraryDialogUrl(mode)
            : defaultPromptLibraryDialogUrl(mode);
        openTaskpaneDialog({
            dialogUrl,
            requireAuth: true,
            isAuthenticated: options.isAuthenticated,
            options: promptLibraryDialogOptions,
            onOpenFailed: (error) => {
                options.onPromptLibraryOpenFailed?.(error);
            },
            onOpened: options.onPromptLibraryOpened,
            onMessage: options.onPromptLibraryMessage
                ? (arg) => {
                    const message = parseJsonMessage(arg.message, logPrefix, "prompt library");
                    if (message !== null) {
                        options.onPromptLibraryMessage?.(message);
                    }
                }
                : undefined,
            onDialogEvent: options.onPromptLibraryDialogEvent,
        });
    };
    return {
        openSettingsDialog,
        openPromptLibraryDialog,
    };
}
